import {
    AppBar,
    Box,
    Toolbar,
    Typography
} from "@mui/material";

import React from "react";
import teneraIcon from "../../assets/images/logo-tenera-public-dashboard.svg";

export const APPBAR_ID = "tenera_appbar";

interface MainAppBarProps {
    updatedTime?: Date;
}

export const PublicPropertyDashboardMainBar: React.FC<MainAppBarProps> = ({ updatedTime }) => {
    return (
        <AppBar
            id={APPBAR_ID}
            position="fixed"
            sx={{
                background: "linear-gradient(180deg, #FFFFFF 0%, #F9F9F9 36.5%, #EEEEEE 100%)",
                borderBottom: theme => `2px solid ${theme.palette.primary.main}`,
                zIndex: theme => theme.zIndex.drawer + 1,
                transition: theme => theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                })
            }}
        >
            <Toolbar sx={{ flexWrap: "wrap" }}>
                <Box display="flex" gap={2} alignItems="center">
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                        }}
                    >
                        <img
                            src={teneraIcon}
                            alt="Tenera Logo"
                            style={{ height: "50px" }}
                        />
                    </Box>
                    <Box display="flex" flexDirection="column">
                        <Box display="flex" fontWeight={500} lineHeight={1}>
                            <Typography color="text.primary">
                                Tenera&nbsp;
                            </Typography>
                            <Typography color="primary.main">
                                Track
                            </Typography>
                        </Box>
                        <Typography
                            noWrap
                            fontSize="1.5rem"
                            fontWeight={300}
                            color="text.primary"
                        >
                            ISSUE DASHBOARD
                        </Typography>
                    </Box>
                </Box>
                {updatedTime && (
                    <Box display="flex" alignItems="flex-end" justifyContent="flex-end" ml="auto" mt="auto" color="GrayText">
                        <Typography variant="caption">
                            Last updated: {updatedTime.toLocaleString()}
                        </Typography>
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    );
};